import type { CSSProperties } from 'react';

interface ContactFormData {
  contact_first_name: string;
  contact_last_name: string;
  contact_email: string;
  contact_mobile: string;
  contact_phone: string;
  contact_designation: string;
  contact_department: string;
  [key: string]: unknown;
}

interface CustomerFormContactSectionProps {
  expanded: boolean;
  onToggle: () => void;
  formData: ContactFormData;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  styles: Record<string, CSSProperties>;
}

export default function CustomerFormContactSection({
  expanded,
  onToggle,
  formData,
  onChange,
  styles,
}: CustomerFormContactSectionProps) {
  return (
    <div style={styles.section}>
      <div
        style={styles.collapsibleHeader}
        onClick={onToggle}
      >
        <span style={styles.sectionTitle}>
          {expanded ? '▼' : '▶'} Contact Person Details
        </span>
        <span style={styles.expandHint}>
          {expanded ? 'Collapse' : 'Expand'}
        </span>
      </div>

      {expanded && (
        <div style={styles.collapsibleContent}>
          {/* First Name / Last Name for Contact Person */}
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>First Name</label>
              <input
                type="text"
                name="contact_first_name"
                style={styles.input}
                value={formData.contact_first_name}
                onChange={onChange}
                placeholder="Contact first name"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Last Name</label>
              <input
                type="text"
                name="contact_last_name"
                style={styles.input}
                value={formData.contact_last_name}
                onChange={onChange}
                placeholder="Contact last name"
              />
            </div>
          </div>

          {/* Email / Mobile */}
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Email</label>
              <input
                type="email"
                name="contact_email"
                style={styles.input}
                value={formData.contact_email}
                onChange={onChange}
                placeholder="Contact email"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Mobile</label>
              <input
                type="tel"
                name="contact_mobile"
                style={styles.input}
                value={formData.contact_mobile}
                onChange={onChange}
                placeholder="Mobile number"
              />
            </div>
          </div>

          {/* Work Phone */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Work Phone</label>
            <input
              type="tel"
              name="contact_phone"
              style={styles.input}
              value={formData.contact_phone}
              onChange={onChange}
              placeholder="Work phone"
            />
          </div>

          {/* Designation / Department */}
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Designation</label>
              <input
                type="text"
                name="contact_designation"
                style={styles.input}
                value={formData.contact_designation}
                onChange={onChange}
                placeholder="Job title"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Department</label>
              <input
                type="text"
                name="contact_department"
                style={styles.input}
                value={formData.contact_department}
                onChange={onChange}
                placeholder="Department"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
